import { createCustomPropertiesResult } from './CustomPropertiesResult';
import { getAdapter } from '../../adapters/AdapterManager';
import CommonAdapter from '../../adapters/CommonAdapter';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import saveExtensionCustomProperties from '../../services/saveExtensionCustomProperties';
import ApiErrorCode from '../ApiErrorCode';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { returnErrorIfUserCannotEditItem } from '../sharedProperties/itemPermissions';
import { getExtensionId } from 'owa-addins-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export interface SaveCustomPropertiesArgs {
    customProperties: {};
}

export default async function saveCustomPropertiesApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: SaveCustomPropertiesArgs,
    callback: ApiMethodCallback
) {
    const adapter: CommonAdapter = getAdapter(hostItemIndex) as CommonAdapter;
    const extensionId = getExtensionId(controlId);
    const serializedCustomProperties = JSON.stringify(data.customProperties);
    let itemId = adapter.getItemId();
    let itemOwner;

    try {
        if (returnErrorIfUserCannotEditItem(adapter, callback)) {
            return;
        }

        if (!itemId) {
            const composeAdapter = adapter as MessageComposeAdapter;
            itemId = await composeAdapter.saveItem();
        }

        if (adapter.isSharedItem && adapter.getSharedProperties && adapter.isSharedItem()) {
            const sharedProperties = adapter.getSharedProperties();
            itemOwner = sharedProperties.owner;
        }

        const response = await saveExtensionCustomProperties(
            extensionId,
            itemId,
            itemOwner,
            serializedCustomProperties
        );
        if (isFeatureEnabled('addin-delegateAccess')) {
            callback(createSuccessResult());
        } else {
            callback(createCustomPropertiesResult(response.ErrorMessage, response.WasSuccessful));
        }
    } catch (e) {
        callback(createErrorResult(ApiErrorCode.GenericResponseError));
    }
}
